import { FC } from 'react';
import { makeStyles } from '@material-ui/styles';
import { DeleteTrashLine, Text } from '@bizzabo/design-system';
import MenuItem from './MenuItem';

interface DeleteMessageActionProps {
    onDeleteClicked: () => void;
}

const DeleteMessageAction: FC<DeleteMessageActionProps> = ({ onDeleteClicked }) => {
    const classes = useStyles();

    return (
        <MenuItem onClick={onDeleteClicked}>
            <div className={classes.icon}>
                <DeleteTrashLine />
            </div>
            <Text variant="t81">Delete message</Text>
        </MenuItem>
    );
};

const useStyles = makeStyles(
    () => ({
        icon: { marginRight: 10, marginTop: 2 },
    }),
    {
        classNamePrefix: DeleteMessageAction.name,
    }
);

export default DeleteMessageAction;
